import React from "react";
import { Timeline, Typography } from "antd";
import { FaClock, FaHome, FaCar, FaPhone, FaMapPin } from "react-icons/fa";
import { MdAlternateEmail } from "react-icons/md";
import language from "../../resources/languages/fa_IR";

const { Components: { Support } } = language

export default function Index() {

    return (
        <>
            <Timeline
                className={'support-timeline'}
                items={[
                    {
                        dot: <FaCar size={20} />,
                        children: Support.company,
                    },
                    {
                        dot: <FaPhone size={20} />,
                        children: <Typography.Link style={{fontSize:18,letterSpacing:2}} href={`tel:+9821${Support.tel}`}>{Support.tel}</Typography.Link>,
                    },
                    {
                        dot: <FaClock size={20} />,
                        children: Support.time,
                    },
                    {
                        dot: <MdAlternateEmail size={20} />,
                        children: <Typography.Link href={`mailto:${Support.email}`}>{Support.email}</Typography.Link>,
                    },
                    {
                        dot: <FaHome size={20} />,
                        children: Support.address,
                    },
                    {
                        dot: <FaMapPin size={20} />,
                        children: Support.zipCode,
                    },
                ]}
            />
            <div style={{width: '100%', display: 'flex'}}>
                <img alt={Support.company} src={require('../../resources/media/logo.png')} width={200} style={{margin: 'auto'}} />
            </div>
        </>
    )
}
